import React from 'react'

import { NumberOfColumns } from '../containers/ColumnLayoutService'

import { MultiColumnIcon } from './MultiColumnIcon'
import { ColumnAction, Container, Rectangle, RightColumnAction } from './styles'

export const ColumnActions: React.FC<{
  numberOfColumnsOnMobile: number
  setNumberOfColumnsOnMobile: (x: NumberOfColumns) => void
}> = ({ numberOfColumnsOnMobile, setNumberOfColumnsOnMobile }) => {
  return (
    <Container data-testid={`ColumnActions, numberOfColumnsOnMobile=${numberOfColumnsOnMobile}`}>
      <ColumnAction
        aria-label='Select One-Column Layout'
        data-testid='one-column-action'
        onClick={() => setNumberOfColumnsOnMobile(1)}
      >
        <Rectangle height='12px' isSelected={numberOfColumnsOnMobile === 1} width='12px' />
      </ColumnAction>
      <RightColumnAction
        aria-label='Select Two-Column Layout'
        data-testid='two-column-action'
        onClick={() => setNumberOfColumnsOnMobile(2)}
      >
        <MultiColumnIcon isSelected={numberOfColumnsOnMobile === 2} />
      </RightColumnAction>
    </Container>
  )
}
